import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  ReportProblem as ReportProblemIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { eventService } from '../../services/eventService';

type Props = {
  eventId: number | string;
  disabled?: boolean;
  onDone?: (kind: 'ack' | 'false_positive' | 'resolve') => void;
  onError?: (message: string) => void;
};

/** 관제·시설 화면 공통 이벤트 ACK (P1-08 / P1-11) */
const AlertAckButtons: React.FC<Props> = ({ eventId, disabled, onDone, onError }) => {
  const run = async (falsePositive: boolean) => {
    try {
      await eventService.ackEvent(eventId, falsePositive);
      onDone?.(falsePositive ? 'false_positive' : 'ack');
    } catch {
      onError?.('이벤트 확인 API에 실패');
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', gap: 0.25 }}>
      <Tooltip title="확인">
        <span>
          <IconButton size="small" color="primary" disabled={disabled} onClick={() => run(false)}>
            <CheckCircleIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="오탐">
        <span>
          <IconButton size="small" color="warning" disabled={disabled} onClick={() => run(true)}>
            <ReportProblemIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="해결(확인과 동일 API)">
        <span>
          <IconButton size="small" disabled={disabled} onClick={() => run(false)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default AlertAckButtons;
